module.exports = __webpack_public_path__ + "img/site_example.23b8215f.jpg";